export {
  ActivityBorderDecorator,
  ActivityBorderDecoratorRequest,
  ActivityGroupingDecorator,
  createActivityBorderMiddleware,
  createActivityGroupingMiddleware,
  DecoratorComposer,
  useDecoratorRequest,
  type ActivityBorderDecoratorProps,
  type DecoratorMiddleware,
  type InferDecoratorRequest
} from 'botframework-webchat-api/decorator.js';
export { BorderFlair, BorderLoader, WebChatDecorator } from 'botframework-webchat-component/decorator.js';
